import { Comment } from "@ant-design/compatible";
import { Button, Form, List, Tag } from "antd";
import styled from "styled-components";

export const CommentItem = styled(Form.Item)`
  margin-bottom: 8px;
`;

export const StyledComment = styled(Comment)`
  .ant-comment-content-author-time {
    color: #575757;
  }
  .ant-comment-content-author-name {
    color: rgba(0, 0, 0, 0.8);
  }

  .ant-comment-inner {
    border-radius: 20px;
    padding: 8px;
  }

  .ant-comment-actions {
    margin-top: 8px;
  }

  .ant-comment-avatar {
    cursor: default;
  }
`;

export const ReplyButton = styled(Button)`
  padding: 0;
`;

export const CommentTag = styled(Tag)`
  cursor: default;
`;

export const TagWrapper = styled.div`
  margin-left: 10px;
  font-size: 12px;
`;

export const StyledList = styled(List)`
  .ant-list-header {
    padding-top: 0;
    padding-bottom: 8px;
  }

  .ant-list-items {
    padding-top: 8px;
  }
`;
